module.exports = function() {
  return new Worker(__webpack_public_path__ + "94fe62e50a4044e1cc0d.worker.js");
};